import { create } from 'zustand'
import type { MetaData } from '@/types/meta'

interface MetadataState {
  metadata: MetaData | null
  setMetadata: (metadata: MetaData) => void
}

const useMetadataStore = create<MetadataState>(set => ({
  metadata: null,
  setMetadata: metadata => set({ metadata })
}))

export default useMetadataStore
